import { Diamond } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-cinzel text-sm font-semibold uppercase tracking-[0.3em] text-navy">
          {item}
        </span>
        <Diamond size={9} className="fill-gold text-gold" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const { s } = useLang();
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-engraved bg-paper-cream py-4"
    >
      <div className="flex w-max animate-marquee">
        <Row items={s.marquee} />
        <Row items={s.marquee} />
      </div>
    </div>
  );
};

export default Marquee;
